import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22fonts.ts%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:[{%22path%22:%22../../public/fonts/Gilroy/Gilroy-Regular.woff%22},{%22path%22:%22../../public/fonts/Gilroy/Gilroy-SemiBold.woff%22,%22weight%22:%22600%22},{%22path%22:%22../../public/fonts/Gilroy/Gilroy-Bold.woff%22,%22weight%22:%22700%22}]}],%22variableName%22:%22gilroy%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'gilroy', 'gilroy Fallback'",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
